const CookieNotice = () => {
  return (
    <div className="bg-slate-900 min-h-screen pt-24 pb-16" data-testid="cookie-notice-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="inline-block text-xs tracking-widest text-gray-400 border border-slate-700 rounded-full px-4 py-1.5 mb-4">
            LEGAL
          </span>
          <h1 className="text-4xl sm:text-5xl heading-font text-white mb-2">Cookie Notice</h1>
          <p className="text-sm text-gray-500">Last updated: 22 April 2026</p>
        </div>

        <div className="prose-legal text-gray-300 space-y-8 leading-relaxed">
          <p>
            This Cookie Notice explains how Audio Apex (a trading name of GL Music Ltd) uses cookies and similar technologies on our website (audioapex.co.uk).
          </p>

          <section>
            <h2 className="text-xl heading-font text-white mb-3">What Are Cookies?</h2>
            <p>
              Cookies are small text files placed on your device when you visit a website. They help the site function, remember your preferences, and understand how the site is used.
            </p>
          </section>

          <section>
            <h2 className="text-xl heading-font text-white mb-3">The Cookies and Analytics We Use</h2>

            <div className="space-y-4">
              <div>
                <h3 className="text-base font-medium text-white mb-2">Essential cookies</h3>
                <p className="text-gray-400">
                  These are necessary for the website to work properly and to keep it secure. For example, if you log into a private/admin area of the site, a session cookie keeps you signed in. These cannot be switched off, as the site would not function without them.
                </p>
              </div>

              <div>
                <h3 className="text-base font-medium text-white mb-2">Analytics</h3>
                <p className="text-gray-400">
                  We may use privacy-focused analytics to understand how visitors use our site so we can improve it, in a way that does not identify you personally. If we use a provider that sets non-essential cookies, we will ask for your consent first.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl heading-font text-white mb-3">Managing Cookies</h2>
            <p>
              You can control and delete cookies through your browser settings. Most browsers let you see what cookies are stored, delete them, and block them. Please note that blocking essential cookies may affect how the website functions.
            </p>
            <p className="mt-3">
              For guidance on managing cookies in your browser, visit{' '}
              <a
                href="https://www.aboutcookies.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white underline underline-offset-2 hover:text-[#e2e8f0] transition-colors"
              >
                aboutcookies.org
              </a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl heading-font text-white mb-3">Changes to This Notice</h2>
            <p>
              We may update this Cookie Notice from time to time — for example, if we change our analytics provider. The latest version will always appear on this page.
            </p>
          </section>

          <section className="border-t border-slate-700 pt-6">
            <h2 className="text-xl heading-font text-white mb-3">Contact</h2>
            <p className="text-gray-400 text-sm">
              For questions about our use of cookies, contact us at info@audioapex.co.uk.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;
